<template>
  <div class="padding-card-c grey">    
    <v-row style="font-size: small; font-weight: bold;">
      <v-col cols="12">
        <v-card color="white">
          <div class="d-flex flex-no-wrap justify-space-between">
             <v-list-item>                         
              <v-list-item-content>
                <v-col class="px-1 text-left" cols="1">
                  <span>Fecha</span>
                </v-col> 
                <v-col class="px-1 text-left" cols="2">
                  <span>Banco origen</span>
                </v-col>
                <v-col class="px-1 text-left" cols="1">
                  <span>Monto</span>
                </v-col>
                <v-col class="px-1 text-left" cols="1">
                  <span>Estado</span>
                </v-col>
                <v-col class="px-1 text-left" cols="3">
                  <span>Lote y nombre
                  </span>
                </v-col>                                   
                <v-col class="px-1 text-left" cols="4">
                  <span>Concepto</span>
                </v-col>          
                 
              </v-list-item-content>
              <v-list-item-action class="mx-0 text-left">
                 Ver                
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-card>
      </v-col>        
    </v-row>

    <v-row v-for="(deposit, index) in ShowDeposits" :key="index" style="font-size: small; font-weight: bold;">
      <v-col cols="12">
        <v-card color="white">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-list-item>                         
              <v-list-item-content>
                <v-row>
                  <v-col class="px-1 text-right" cols="1">
                    <span>{{ $dayjs(deposit.fecha_pago_usuario).format('DD-MM-YYYY') }}</span>
                  </v-col> 
                  <v-col class="px-1" cols="2">
                    <span>{{deposit.banco_origen}} - Ref:{{deposit.referencia_bancaria}}</span>
                  </v-col>
                   <v-col class="text-right" cols="1">
                    <span>{{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(deposit.monto_reportado) }}</span>
                  </v-col> 
                  <v-col class="px-1" cols="1">
                    <span>{{deposit.status_pago_usuario}}</span>
                  </v-col>
                  <v-col class="px-1" cols="3">
                    <span>{{deposit.customer.manzana}}{{deposit.customer.lotenum}}
                        {{deposit.customer.username.split(' ').slice(0, 3).join(' ') + '...'}}
                    </span>
                  </v-col>                                   
                  <v-col class="px-1" cols="4">
                    <span>{{deposit.MaintenanceFee.concept}} {{deposit.concept}}</span>
                  </v-col>          
                 
                               
                </v-row>
              </v-list-item-content>

              <v-list-item-action>                
                <modal-deposit :payment="deposit" :index="index" @aceptar="aceptar" @rechazar="rechazar" @eliminar="eliminar"></modal-deposit>             
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-card>
      </v-col>      
    </v-row>
    <div class="text-center">
      <v-pagination v-model="page" :length="length"></v-pagination>
    </div>
  </div>
</template>



<script>
import maintenancePaymentsService from '@/services/admin/maintenancePayments';
import ModalDeposit from '../../components/ModalDeposit.vue';

export default {
  props: {
    request: {
      type: Array,
      default: () => [],
    },
  },
  components: { ModalDeposit },
  data: () => ({
    page: 1,
    deposits: [],  
  }),
  created() {
    this.getDeposits();
  },
  computed: {   
    length() {
      return Math.ceil(this.deposits.length / 10);
    },
    ShowDeposits() {
      const { page, deposits } = this;
      const number = 10; // Numero de elementos a mostrar por página
      return deposits.slice((page - 1) * number, page * number);
    },
  },
  methods: {
    
    getDeposits() {
      maintenancePaymentsService.fetchDeposits().then((response) => {        
        this.deposits = response.data;             
        this.deposits.sort(function(a,b) {
            var x = a.fecha_pago_usuario;
            var y = b.fecha_pago_usuario;
            return x < y ? -1 : x > y ? 1 : 0;
        });
      });      
    },    
    
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },
     aceptar(id) {
      maintenancePaymentsService.aceptarDeposit(id)
      .then(res=>{
        console.log(res.data);
        this.$swal('Deposito Aceptado', 'El pago ha sido completado', 'success');
        this.getDeposits();
      }).catch((error) => {
          console.log(error);
          this.$swal('Error al aceptar', error.response.data.message, 'warning');
        });
    },
    rechazar(id, motivo) {
      maintenancePaymentsService.rechazarDeposit(id, motivo)
      .then(res=>{
        console.log(res);
        this.$swal('Deposito Rechazado', 'El pago no se ha completado, el usuario debe verificar los datos del depósito', 'success');
        this.getDeposits();
      }).catch((error) => {
          console.log(error);
          this.$swal('Error al rechazar', error.response.data.message, 'warning');
        });
    },
    eliminar(id){
      maintenancePaymentsService.eliminarDeposit(id).then(res=>{
        console.log(res);
        this.$swal('Deposito Eliminado', 'El usuario deberá volver a capturar su deposito', 'success');
        this.getDeposits();
      }).catch((error) => {
          console.log(error);
          this.$swal('Error al eliminar', error.response.data.message, 'warning');
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>